import { useContext } from 'react'
import { inputContext } from '../../context/inputsContext'
import Heading from './Heading'
import ChartTabs from './Tabs'

const TabSection = () => {
  const { values } = useContext(inputContext)
  return (
    <>
      <Heading town={values.location?.name || ''} />
      <ChartTabs />
    </>
  )
}

export default TabSection
